import(/* webpackMode: "eager" */ "/vercel/path0/app/_components/global/footer.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/app/(zoc)/zoc/components/zocBotState.tsx")